import type { EmberChangeset } from "ember-changeset";
import type { ValidatorMap } from "ember-changeset/types";

/**
 * This methods mimics the behaviour of changeset.validate, but does update
 * the internal state of the changeset (thus does not set the errors attribute
 * for instance).
 * Note that the current implementation is simplified.
 *
 * @see https://github.com/validated-changeset/validated-changeset/blob/master/src/index.ts#L752
 */
export default function isChangesetValid(
  changeset: EmberChangeset,
  validationMap: ValidatorMap
) {
  for (const validation in validationMap) {
    if (validationMap.hasOwnProperty(validation)) {
      // _validate is an internal method but still exposed by the IChangeset interface.
      const result = changeset._validate(
        validation,
        changeset.get(validation),
        {}
      );
      if (!Array.isArray(result) && result !== true) {
        return false;
      } else if (
        Array.isArray(result) &&
        result.some(value => value !== true)
      ) {
        return false;
      }
    }
  }

  return true;
}
